export default __webpack_public_path__ + "static/media/fav.413f6112.svg";